/**
 * @generated SignedSource<<63a798f0982bb0c626c2506171f7caa5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImageCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_viewer" | "ProductImageCarouselRefetch_viewer">;
  readonly " $fragmentType": "ProductImageCarousel_viewer";
};
export type ProductImageCarousel_viewer$key = {
  readonly " $data"?: ProductImageCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductImageCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductCarouselItem_viewer"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "fetchPhotos",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "itemId",
          "value": ""
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductImageCarouselRefetch_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f28127d3d70908764d43756fdea33bb3";

export default node;
